import type { TreeViewSelectNode } from '../../../TreeViewSelect';
import type { DiamRoleDetails } from '../../diamApi';

export function mapAssignRoleTree(
  roles: readonly DiamRoleDetails[],
  assignedRoleIds?: ReadonlySet<string>,
): TreeViewSelectNode[] {
  const roleNodes: TreeViewSelectNode[] = roles
    .filter(role => !assignedRoleIds?.has(role.roleId))
    .map(role => ({
      id: `role:${role.roleId}`,
      label: role.name,
      children: (role.attributes ?? []).map(attribute => ({
        id: `attribute:${attribute.name}`,
        label: attribute.name,
      })),
    }));

  return [
    {
      id: 'roles',
      label: 'Roles',
      children: roleNodes,
    },
  ];
}

export function mapAssignTeamTree(
  teamId: string,
  teamName: string,
): TreeViewSelectNode[] {
  return [
    {
      id: `team:${teamId}`,
      label: teamName,
    },
  ];
}
